export function formattedAdditionalCommentsTextarea(salesBrief: string, formValue: string, isTextArea: boolean) {
  let parsedValue = isTextArea
    ? formValue
    : salesBrief.length > 1 && formValue.length > 1
      ? `${salesBrief} ${formValue}`
      : salesBrief;
  return parsedValue;
}
